"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2c4.4183 0 8 3.5817 8 8v1h-9V2h1zm1 7h4.917C19.4955 6.4875 17.5125 4.5045 15 4.083V9z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8c2.13 0 4.0674-.8337 5.5001-2.1906C17.0384 18.3526 18 16.2878 18 14v-1h-7V6h-1zm-6 8c0-2.973 2.1623-5.441 5-5.917V15h6.9171c-.2199 1.3123-.8657 2.4798-1.7922 3.3572C13.0487 19.3764 11.5983 20 10 20c-3.3137 0-6-2.6863-6-6z"
  })];
};

exports.default = _default;